import { useContext } from 'react';
import { TrackerContext } from 'src/tracking/tracker-context';

export const useTracker = () => useContext(TrackerContext);
